import React from 'react';

export default class ThankYou extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <section className='thank'>
                <div className='thank__content'>
                    <h1 className='thank__title'>{this.props.status ? 'Спасибо, заказ отправлен' : 'Упс, ошибка'}</h1>
                    <p className='thank__paragraph'>{this.props.status ? 'В ближайшее время с вами свяжется наш оператор, для уточнения деталей.' : 'Заказ не прошёл. Попробуйте повторить еще раз или свяжитесь с нашим менеджером для помощи'}</p>
                    <button 
                        onClick={
                            this.props.status ? 
                            () => {document.location.href = window.location.origin} : 
                            () => {this.props.updatePart(''); this.props.changeCurrentStage(2)}
                            
                        }
                        className='button button--default-icon thank__button'
                    >
                        {this.props.status ? 'Вернуться на главную' : 'Повторить заказ'}
                        <svg width="58" height="16" viewBox="0 0 58 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M57.7071 8.70711C58.0976 8.31658 58.0976 7.68342 57.7071 7.29289L51.3431 0.928932C50.9526 0.538408 50.3195 0.538408 49.9289 0.928932C49.5384 1.31946 49.5384 1.95262 49.9289 2.34315L55.5858 8L49.9289 13.6569C49.5384 14.0474 49.5384 14.6805 49.9289 15.0711C50.3195 15.4616 50.9526 15.4616 51.3431 15.0711L57.7071 8.70711ZM0 9H57V7H0V9Z" fill="#F9F9F9"/>
                        </svg>
                    </button>
                </div>
                <div className='thank__footer'>
                    <a className='thank__link' href="tel:+74954871287">+7 (495) 487 1287</a>
                    <a className='thank__link' href="mailto: hello@mobo.su">hello@mobo.su</a>
                </div>
            </section>
        )
    }
}